import React from "react";
import {Grid2, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {CartonGradeCatalogDTO, RequestOverviewRowDTO} from "@/api/data-contracts";
import {RequestI18N, CommonI18N} from "@/translations";
import {GradeStatusIndicator} from "@/common/grade-indicator/GradeStatusIndicator";
import {GradeParametersTable} from "@/lib/components/GradeParametersTable";
import {stringField} from "@/common/fields/string-field";
import {TOOLTIP_DELAY_MS} from "@/constants";

export interface RequestCartonGradeCellProps {
    row: RequestOverviewRowDTO;
    grades: CartonGradeCatalogDTO[] | undefined;
    locale: string;
}

/**
 * Renders the carton grade cell for the request overview table,
 * including a tooltip with full grade parameters.
 */
export const RequestCartonGradeCell: React.FC<RequestCartonGradeCellProps> = ({row, grades, locale}) => {
    const {t} = useTranslation();
    const progroupGrade = grades?.find((g) => g.values?.code === row.cartonGrade?.code);
    const grade: CartonGradeCatalogDTO = progroupGrade || {values: row.cartonGrade};

    return (
        <Tooltip
            title={<GradeParametersTable grade={grade}/>}
            enterDelay={TOOLTIP_DELAY_MS}
            enterNextDelay={TOOLTIP_DELAY_MS}
            placement="right-start"
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: "fit-content",
                        padding: "4px"
                    }
                }
            }}
            arrow
        >
            <Grid2
                container
                direction="row"
                justifyContent="space-between"
                flexWrap="nowrap"
                spacing="8px"
            >
                <Grid2>
                    {
                        stringField(
                            grade?.values?.code,
                            t(RequestI18N.details.field.variety),
                            t(CommonI18N.message.notGiven)
                        ).value
                    }
                </Grid2>
                <Grid2>
                    <GradeStatusIndicator importedAt={grade.importedAt} size="small"/>
                </Grid2>
            </Grid2>
        </Tooltip>
    );
};
